export default {"src":"/_next/static/media/writingBg.da16fb50.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};